export type Break = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

export interface BreakPoint {
    xs: number
    sm: number
    md: number
    lg: number
    xl: number
    xxl: number
}

export const breakPoints: BreakPoint = {
    xs: 320,
    sm: 600,
    md: 800,
    lg: 1000,
    xl: 1200,
    xxl: 1400,
}

let scrollAnimationFrame = 0

export const disableScroll = (): void => {
    const contentElement: HTMLElement | null = document.querySelector('#root')

    if (contentElement && !document.body.classList.contains('is-scroll-disabled')) {
        if (document.documentElement) {
            const curScroll: number =
                window.scrollY ||
                window.pageYOffset ||
                document.body.scrollTop + (document.documentElement?.scrollTop || 0)

            document.body.classList.add('is-scroll-disabled')
            contentElement.style.top = -curScroll + 'px'
            window.scroll(0, 0)
        }
    }
}

export const enableScroll = (): void => {
    const contentElement: HTMLElement | null = document.querySelector('#root')
    if (contentElement) {
        const bodyScroll: number = parseInt(contentElement.style.top || '0', 10)

        document.body.classList.remove('is-scroll-disabled')

        if (bodyScroll && document.documentElement) {
            window.scroll(0, -bodyScroll)
            contentElement.style.top = ''
        }
    }
}

export const swingTo = (pos: number): number => {
    pos /= 0.5

    if (pos < 1) {
        return 0.5 * Math.pow(pos, 2)
    }

    return -0.5 * ((pos -= 2) * pos - 2)
}

export const doScrolling = (
    scrollTargetY: number,
    speed: number,
    parent: Window | HTMLElement = window,
    callback?: () => void,
): void => {
    // cancel previous scrolling if new scrolling is triggered
    window.cancelAnimationFrame(scrollAnimationFrame)

    const scrollY = parent instanceof HTMLElement ? parent.scrollTop : parent.scrollY
    let currentTime = 0

    // min time .1, max time .8 seconds
    const time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8))

    /**
     * Tick a scroll point
     */
    function tick(): void {
        currentTime += 1 / 60

        const p = currentTime / time
        const t = swingTo(p)

        if (p < 1) {
            scrollAnimationFrame = window.requestAnimationFrame(tick)
            parent.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t)
        } else {
            parent.scrollTo(0, scrollTargetY)
            if (callback) {
                callback()
            }
        }
    }

    tick()
}

export const scrollToElement = (element: string | HTMLElement | null, speed?: number): void => {
    if (typeof element === 'string') {
        element = document.getElementById(element)
    }

    if (element) {
        const duration = speed || 500
        const offsetY = element.getBoundingClientRect().top + window.pageYOffset
        const combinedOffsetY = Math.max(offsetY, 0)

        doScrolling(combinedOffsetY, duration, window)
    }
}
